export const NH_PAYMENTS_INFO_REQUESTED = 'NH_PAYMENTS_INFO_REQUESTED'
export const NH_PAYMENTS_INFO_RECEIVED = 'NH_PAYMENTS_INFO_RECEIVED'

export const NH_PAYMENT_INVOICE_REQUESTED = 'NH_PAYMENT_INVOICE_REQUESTED'
export const NH_PAYMENT_INVOICE_RECEIVED = 'NH_PAYMENT_INVOICE_RECEIVED'

export const NH_SSO_INFO_REQUESTED = 'NH_SSO_INFO_REQUESTED'
export const NH_SSO_INFO_RECEIVED = 'NH_SSO_INFO_RECEIVED'
export const NH_SSO_INFO_CLEAR = 'NH_SSO_INFO_CLEAR'

export const NH_PAGE_PAYMENTS_PRESSED = 'NH_PAGE_PAYMENTS_PRESSED'
export const NH_PAGE_DENTAL_PRESSED = 'NH_PAGE_DENTAL_PRESSED'
export const NH_PAGE_REIMBURSEMENT_PRESSED = 'NH_PAGE_REIMBURSEMENT_PRESSED'
export const NH_PAGE_PRESCRIPTIONS_PRESSED = 'NH_PAGE_PRESCRIPTIONS_PRESSED'
export const NH_PAGE_DRUGS_PRESSED = 'NH_PAGE_DRUGS_PRESSED'

export const MEMBER_CARD_REQUESTED = 'MEMBER_CARD_REQUESTED'
export const MEMBER_CARD_RECEIVED = 'MEMBER_CARD_RECEIVED'
export const MEMBER_CARD_FAILED = 'MEMBER_CARD_FAILED'

export const CLAIMS_REQUESTED = 'CLAIMS_REQUESTED'
export const CLAIMS_RECEIVED = 'CLAIMS_RECEIVED'
export const CLAIMS_FAILED = 'CLAIMS_FAILED'

export const MEMBER_EOB_REQUESTED = 'MEMBER_EOB_REQUESTED'
export const MEMBER_EOB_RECEIVED = 'MEMBER_EOB_RECEIVED'
export const MEMBER_EOB_FAILED = 'MEMBER_EOB_FAILED'

export const CLAIM_DETAILS_REQUESTED = 'CLAIM_DETAILS_REQUESTED'
export const CLAIM_DETAILS_RECEIVED = 'CLAIM_DETAILS_RECEIVED'
export const CLAIM_DETAILS_FAILED = 'CLAIM_DETAILS_FAILED'

export const MEMBER_PLAN_DETAILS_REQUESTED = 'MEMBER_PLAN_DETAILS_REQUESTED'
export const MEMBER_PLAN_DETAILS_RECEIVED = 'MEMBER_PLAN_DETAILS_RECEIVED'
